﻿
declare global {
    var TOOL_BASE_URL: string;
}

export function buildFetchUrl(relativeUrlString) {
    if (window.TOOL_BASE_URL) {
        return window.TOOL_BASE_URL + relativeUrlString;
    }
    else {
        return relativeUrlString;
    }
}